<template>
  <div class="d-flex justify-content-evenly align-items-center col-12 navBar">

    <!-- 1st Col - Home -->
    <div class="nav-item d-flex flex-column justify-content-center align-items-center col"
         @click="navigateTo('home')"
         :class="{ 'active-tab': activeTab === 'home' }">
      <div class="icon-wrapper">
        <img v-if="activeTab === 'home'" :src="require('@/assets/navigation/nav_home_active.png')" alt="Home Icon" class="nav-icon" />
        <img v-else :src="require('@/assets/navigation/nav_home.png')" alt="Home Icon" class="nav-icon" />
      </div>
      <div class="nav-text" :class="{ 'active-text': activeTab === 'home', 'inactive-text': activeTab !== 'home' }">Home</div>
    </div>

    <!-- 2nd Col - How to Play -->
    <div class="nav-item d-flex flex-column justify-content-center align-items-center col"
         @click="navigateTo('howtoplay')"
         :class="{ 'active-tab': activeTab === 'howtoplay' }">
      <div class="icon-wrapper">
        <img v-if="activeTab === 'howtoplay'" :src="require('@/assets/navigation/nav_how_to_play_active.png')" alt="How to Play Icon" class="nav-icon" />
        <img v-else :src="require('@/assets/navigation/nav_how_to_play.png')" alt="How to Play Icon" class="nav-icon" />
      </div>
      <div class="nav-text" :class="{ 'active-text': activeTab === 'howtoplay', 'inactive-text': activeTab !== 'howtoplay' }">How to Play</div>
    </div>

    <!-- 3rd Col - Prizes -->
    <div class="nav-item d-flex flex-column justify-content-center align-items-center col"
         @click="navigateTo('prizes')"
         :class="{ 'active-tab': activeTab === 'prizes' }">
      <div class="icon-wrapper">
        <img v-if="activeTab === 'prizes'" :src="require('@/assets/navigation/nav_prizes_active.png')" alt="Prizes Icon" class="nav-icon" />
        <img v-else :src="require('@/assets/navigation/nav_prizes.png')" alt="Prizes Icon" class="nav-icon" />
      </div>
      <div class="nav-text" :class="{ 'active-text': activeTab === 'prizes', 'inactive-text': activeTab !== 'prizes' }">Prizes</div>
    </div>

    <!-- 3rd Col - Leaderboard (with locked state for free users) -->
    <div class="nav-item d-flex flex-column justify-content-center align-items-center col"
         @click="navigateTo('leaderboard')"
         :class="{ 'active-tab': activeTab === 'leaderboard' && !this.isFreeUser, 'locked-tab': this.isFreeUser }">
      <div class="icon-wrapper">
        <template v-if="this.isFreeUser">
          <!-- Show locked icon for free users -->
          <img :src="require('@/assets/navigation/nav_leaderboard-locked.png')" alt="Leaderboard Locked" class="nav-icon locked-icon" />
        </template>
        <template v-else>
          <!-- Show normal/active icons for paid users -->
          <img v-if="activeTab === 'leaderboard'" :src="require('@/assets/navigation/nav_leaderboard_active.png')" alt="Leaderboard Icon" class="nav-icon" />
          <img v-else :src="require('@/assets/navigation/nav_leaderboard-1.png')" alt="Leaderboard Icon" class="nav-icon" />
        </template>
      </div>
      <div class="nav-text" :class="{ 'active-text': activeTab === 'leaderboard' && !this.isFreeUser, 'inactive-text': activeTab !== 'leaderboard' || this.isFreeUser, 'locked-text': this.isFreeUser }">
        Leaderboard
      </div>
    </div>

    <!-- 4th Col - Profile -->
    <div class="nav-item d-flex flex-column justify-content-center align-items-center col"
         @click="navigateTo('profile')"
         :class="{ 'active-tab': activeTab === 'profile' }">
      <div class="icon-wrapper">
        <img v-if="activeTab === 'profile'" :src="require('@/assets/navigation/nav_profile_active.png')" alt="Profile Icon" class="nav-icon" />
        <img v-else :src="require('@/assets/navigation/nav_profile.png')" alt="Profile Icon" class="nav-icon" />
      </div>
      <div class="nav-text" :class="{ 'active-text': activeTab === 'profile', 'inactive-text': activeTab !== 'profile' }">Profile</div>
    </div>

  </div>
</template>

<script>

import {mapMutations, mapState} from "vuex";
import {mtnServiceIdMap} from "@/config";

export default {
  name: 'FooterComponent',
  props: {
    currentTab: {
      type: String,
      default: 'home'
    }
  },
  data() {
    return {
      routeMap: {
        home: '/',
        howtoplay: '/how-to-play',
        prizes: '/prizes',
        leaderboard: '/leaderboard',
        profile: '/profile'
      }
    }
  },
  computed: {
    ...mapState(['user', 'isFreeUser']),
    activeTab() {
      // Determine active tab based on current route instead of prop
      const currentPath = this.$route.path;

      // Find which tab matches the current route
      for (const [tab, route] of Object.entries(this.routeMap)) {
        if (currentPath === route) {
          return tab;
        }
      }

      // Fallback to prop or default
      return this.currentTab || 'home';
    }
  },
  methods: {
    ...mapMutations(['setIsFreeUser']),
    navigateTo(tab) {
      // Block navigation to leaderboard for free users
      if (tab === 'leaderboard' && this.isFreeUser) {
        // Optionally show a message or trigger an event
        this.$emit('locked-feature-clicked', 'leaderboard');
        console.log('Leaderboard is locked for free users');
        return;
      }

      const route = this.routeMap[tab];
      if (route && this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    checkFreeUser() {
      if (this.user && this.user.serviceId) {
        const serviceId = mtnServiceIdMap.get(this.user.serviceId);
        // Fixed: Set isFreeUser to true when serviceId equals 1 (free users)
        this.setIsFreeUser(serviceId === 1);
        console.log('Is Free User:', this.isFreeUser, 'Service ID:', serviceId);
      }
    }
  },
  beforeMount() {
    this.checkFreeUser()
  },
  watch: {
    // Watch for route changes to ensure active tab updates
    '$route'(to, from) {
      // Force re-render of active tab when route changes
      this.$forceUpdate();
    },
    // Watch for user changes to update free user status
    'user.serviceId'() {
      this.checkFreeUser();
    }
  }
}
</script>

<style scoped>
.navBar {
  background-color: #000;
  border-radius: 10px;
  padding: 5px 5px;
  cursor: pointer;
  z-index: 3;
  width: inherit;
  position: absolute;
  bottom: .5%;
}

.nav-item {
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 8px;
  padding: 8px;
}

/* Active tab with smooth background animation */
.active-tab {
  background-color: #FFCB05;
  animation: slideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(1.05);
}

/* Locked tab styling */
.locked-tab {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.locked-tab:hover {
  transform: none;
  background-color: transparent;
}

/* Locked icon styling */
.locked-icon {
  opacity: 0.6;
  filter: grayscale(50%);
}

/* Slide in animation */
@keyframes slideIn {
  0% {
    background-color: transparent;
    transform: scale(1) translateY(5px);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.08) translateY(-2px);
  }
  100% {
    background-color: #FFCB05;
    transform: scale(1.05) translateY(0);
    opacity: 1;
  }
}

/* Icon wrapper for smooth transitions */
.icon-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-icon {
  width: 40%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Icon animation when active */
.active-tab .nav-icon {
  animation: iconBounce 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

@keyframes iconBounce {
  0% {
    transform: scale(1) translateY(0);
  }
  40% {
    transform: scale(1.15) translateY(-4px);
  }
  70% {
    transform: scale(0.95) translateY(2px);
  }
  100% {
    transform: scale(1) translateY(0);
  }
}

/* Text styles */
.nav-text {
  font-family: 'Clash Display', sans-serif;
  font-weight: 400;
  font-size: 9px;
  text-align: center;
  margin-top: 4px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

/* Active text with color transition */
.active-text {
  color: #000000;
  font-weight: 600;
  animation: textFadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: 0.3px;
}

@keyframes textFadeIn {
  0% {
    color: #FFFFFF;
    transform: translateY(3px);
    opacity: 0.7;
  }
  100% {
    color: #000000;
    transform: translateY(0);
    opacity: 1;
  }
}

/* Inactive text */
.inactive-text {
  color: #FFFFFF;
  font-weight: 400;
}

/* Locked text styling */
.locked-text {
  color: #999999;
  font-weight: 400;
}

/* Hover effects for non-active tabs (not locked) */
.nav-item:not(.active-tab):not(.locked-tab):hover {
  background-color: rgba(255, 203, 5, 0.15);
  transform: translateY(-2px);
}

.nav-item:not(.active-tab):not(.locked-tab):hover .nav-icon {
  transform: scale(1.1);
}

.nav-item:not(.active-tab):not(.locked-tab):hover .nav-text {
  color: #FFCB05;
}

/* Active state press effect (not for locked) */
.nav-item:not(.locked-tab):active {
  transform: scale(0.95);
}

/* Smooth transitions for all state changes */
.nav-item * {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>